import { render } from "./GetInTouch.vue?vue&type=template&id=6e6687ca"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"
script.render = render

export default script